module.exports = __webpack_public_path__ + "img/instagram.a973f804.svg";